<template>
    <div class="preview-seal">
        <div class="conent">
            <div class="tips">
                请保证图片白底或已透明处理并清晰可见
                 <el-button type="text"
                        v-if="imgUrl"
                        @click="showSignEffect = true"
                        class="small-font">预览盖章效果</el-button>
            </div>
            <div class="alert-tips">
                <i class="el-icon-warning"></i>
                <div class="desc">
                    <p>系统会对部分不合格的图片底色进行处理</p>
                    <p>
                        <span v-if="imgSize">当前图片:{{ size }},</span> 请进行图片裁剪或确认制作
                    </p>
                </div>

            </div>
            <div class="img-wrapper">
                <img :src="imgUrl" alt="" width="100%">
            </div>
        </div>
        <div class="footer-btns">
            <el-button
                size="small"
                class="mr-16"
                type="primary"
                @click="goToCropper"
            >图片编辑</el-button>
            <el-button
                size="small"
                type="primary"
                @click="directlyUpload"
            >确认制作</el-button>
        </div>
        <el-dialog
                        title="签署效果"
                        :show-close="false"
                        :visible.sync="showSignEffect"
                        append-to-body
                        width="790px"
                    >
                        <div class="sign-effect-preview-container">
                            <div class="img-wrapper middle-center">
                                <img class="img"
                                    :src="imgUrl"
                                    alt>
                            </div>
                        </div>
                        <div slot="footer"
                             class="text-center">
                            <el-button type="primary"
                                       @click="showSignEffect = false">我知道了</el-button>
                        </div>
                    </el-dialog>
    </div>
</template>

<script>
export default {
    name: "PreviewSeal",
    props: {
        imgUrl: String,
        imgSize: Number,
        sealType: String,
    },
    computed: {
        size() {
            return parseInt(this.imgSize) + 'KB' ;
        },
        tooBigger() {
            return this.imgSize > 20;
        },
    },
    data() {
        return {
            showSignEffect: false
        };
    },
    methods: {
        goToCropper() {
            this.$emit('changeStep');
        },
        directlyUpload() {
            this.$emit('directlyUpload', null, this.imgUrl);
        },
        reUpload() {
            this.$emit('onCancel');
        }
    }
};
</script>

<style lang="less" scoped>
.preview-seal {
    .conent {
        padding: 0 24px;
    }
    .tips {
        line-height: 12px;
    }
    .alert-tips {
        display: flex;
        margin-top: 10px;
        padding: 11px 17px;
        background: #fdf6ec;
        align-items: flex-start;
        .el-icon-warning {
            color: #e6a23c;
            margin-top: 2px;
            margin-right: 10px;
        }
        .desc {
            color: #001330;
            line-height: 20px;
        }
    }
    .img-wrapper {
        margin-top: 24px;
        background: rgba(0, 19, 48, 0.08);
        padding: 24px;
    }

    .footer-btns {
        display: flex;
        height: 64px;
        padding: 16px 24px;
        justify-content: flex-end;
        align-items: center;
        margin-top: 40px;
        border-top: 1px solid #E5E7EA;
        .mr-16 {
            margin-right: 16px;
        }
        .link {
            font-size: 12px;
            font-weight: normal;
        }
        .link:hover{
            cursor: pointer;
            color: #44A0FF;
        }
        .el-button+.el-button {
            margin-left: 0;
        }
    }
}
.sign-effect-preview-container {
        width: 600px;
        height: 300px;
        margin: 0 auto;
        overflow: hidden;
        position: relative;
        background: url('../../assets/images/seal/sign-effect-preview-bg.png') no-repeat  center;
        background-size: 600px 300px;

        .img-wrapper {
            width: 150px;
            height: 150px;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
                max-width: 100%;
                max-height: 100%;
            }
        }
    }

</style>